/* ============================================================
   ДИЗАЙН-ТОКЕНИ appointMe (платформа).
   Айдентика «вишня на кремі»: теплий крем + вишня-oxblood + карамель
   + шоколадний хедер (та сама гама, що й маркетинг-лендінг).
   Салонні публічні сторінки мають ВЛАСНІ теми (workspace_settings) —
   ця палітра лише для платформного UI (кабінети/лендінг).
   Ключі кольорів лишаються сумісними з темою MUI (gold=primary тощо).
   ============================================================ */

export const tokens = {
  color: {
    // Поверхні
    bg: "#f6f1e8", // теплий крем (замість чисто-білого)
    bgAlt: "#efe6d8", // світліші секції
    surface: "#fdfaf4", // картки / Paper
    dark: "#241713", // хедер/футер — темний шоколад

    // Текст
    ink: "#2a1b16", // основний текст (шоколад)
    inkSoft: "#6f5a4e", // вторинний текст
    onDark: "#f2e9df", // текст на темному
    onDarkSoft: "#b7a293",

    // Акценти платформи (ключі сумісні з темою MUI)
    gold: "#6c1129", // основний акцент → вишня-oxblood (primary)
    goldDeep: "#56081f", // насиченіший (primary.dark)
    goldLight: "#f0dfe5", // світлий відтінок primary
    olive: "#a9713b", // карамель-бронза — вторинний акцент (secondary)

    // Лінії / стани
    line: "rgba(42, 27, 22, 0.12)",
    lineStrong: "rgba(42, 27, 22, 0.22)",
    error: "#c03528",
    success: "#3d7a4e",
  },
  font: {
    family: "'Montserrat', system-ui, -apple-system, 'Segoe UI', sans-serif",
  },
  radius: { sm: 8, md: 12, lg: 16 },
  // М'які багатошарові тіні — теплі, у тон шоколадного інку.
  shadow: {
    soft: "0 1px 2px rgba(42,27,22,0.05), 0 2px 8px rgba(42,27,22,0.06)",
    card: "0 2px 6px rgba(42,27,22,0.06), 0 10px 24px rgba(42,27,22,0.08)",
    hover: "0 8px 24px rgba(108,17,41,0.18)",
    header: "0 1px 0 rgba(36,23,19,0.05), 0 8px 28px rgba(36,23,19,0.14)",
  },
};

export default tokens;
